import * as z from 'zod'

export const roomSearchSchema = z.object({
  auth_url: z.string().optional(),
})

export type RoomSearchModel = z.infer<typeof roomSearchSchema>

export const defaultRoomSearch: RoomSearchModel = {
  auth_url: undefined,
}
